<template>

  <div class="card">
    <div class="card-header">
      {{ jobBoard.name }}
    </div>
    <div class="card-body">
      <img
        :src="jobBoard.logo_url"
        style="max-width: 200px"
        class="mb-2">

      <p>{{ jobBoard.description }}</p>

      <JobAdvertiseBoardsItemCatho
        v-if="showOptionsJobBoard === 'catho'"
        @cancel="showOptionsJobBoard = false"
        @save="setParams"
        :errorMessage="error_message"
        :initParams="params"
        :loading="loading" />

      <div :class="{'box-loading': loading}">
        <button
          v-if="!posting"
          type="button"
          @click="postJobBoard(jobBoard.key)"
          class="btn btn-primary" 
          :disabled="disabled">{{ $t('Publish') }}</button>
        <button
          v-if="hasParams && posting"
          type="button"
          @click="postJobBoard(jobBoard.key)"
          class="btn btn-primary" 
          :disabled="disabled">{{ $t('Edit') }}</button>
        <button
          v-if="posting"
          type="button"
          @click="removePost(posting._id)"
          class="btn btn-secondary"
          :disabled="disabled">{{ $t('Remove') }}</button>
      </div>

    </div>
  </div>

</template>

<script>
import JobAdvertiseBoardsItemCatho from './JobAdvertiseBoardsItemCatho'

export default {
  name: 'JobAdvertiseBoard',
  components: {
    JobAdvertiseBoardsItemCatho
  },
  props: [
    'jobBoard'
  ],
  data () {
    return {
      loading: false,
      showOptionsJobBoard: false,
      error_message: null
    }
  },
  computed: {
    postings () {
      return this.$store.getters.getPostings
    },
    posting () {
      return this.postings.filter((p) => {
        return p.job_board === this.jobBoard.key
      })[0]
    },
    job () {
      return this.$store.getters.getJob
    },
    hasParams () {
      return ['catho'].includes(this.jobBoard.key)
    },
    params () {
      return this.posting && this.posting.params ? this.posting.params : {}
    },
    integrationSummaries () {
      return this.$store.getters.getIntegrationSummaries
    },
    disabled () {
      return this.jobBoard.key === 'catho' && !this.integrationSummaries.find(v => v.key === 'catho')
    }
  },
  created () {
  },
  methods: {
    postJobBoard (key) {
      if (this.hasParams) {
        this.showOptionsJobBoard = key
      } else {
        this.postJob(key)
      }
    },
    setParams (value) {
      this.postJob(this.showOptionsJobBoard, value)
    },
    /*
    postJob
    */
    postJob (key, params = null) {
      this.loading = true

      Promise.resolve().then(() => {
        if (this.posting && this.posting._id) {
          return this.$store.dispatch('updatePosting', {
            _id: this.posting._id,
            params: params
          })
        } else {
          return this.$store.dispatch('createPosting', {
            job_id: this.job._id,
            job_board: key,
            params: params
          })
        }
      })
      .then(() => {
        return this.$store.dispatch('refreshSelectPostings')
      })
      .then(() => {
        this.showOptionsJobBoard = false
        this.loading = false
      }).catch(err => {
        if (err.response.data.name === 'UnprocessableEntity') {
          this.error_message = err.response.data.message
        }
        this.loading = false
      })
    },
    /*
    removePost
    */
    removePost (id) {
      this.loading = true

      this.$store
      .dispatch('deletePosting', id)
      .then((result) => {
        this.$store
        .dispatch('refreshSelectPostings')
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobAdvertise/JobAdvertiseBoardsItem.vue